var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 0.5,
    y: 0.5,
    fillRule: "nonzero",
    stroke: "#587E85",
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M7.5 4.25c.345 0 .625.28.625.625v2h2l.102.008c.267.044.477.257.516.525l.007.092-.007.092c-.044.302-.304.533-.618.533h-2v2l-.007.092c-.044.302-.304.533-.618.533-.345 0-.625-.28-.625-.625v-2h-2l-.092-.007c-.302-.044-.533-.304-.533-.618 0-.345.28-.625.625-.625h2v-2l.007-.092c.044-.302.304-.533.618-.533z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStaffIcon);
export default __webpack_public_path__ + "static/media/add-staff-icon.3c5ec3dc0c30371dabc6e27d6422484f.svg";
export { ForwardRef as ReactComponent };